import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { TextField, Button, Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { actionGetCoupon, actionResetCoupon, actionEndCouponLoading } from 'actions';
import { useDispatch, useSelector } from 'react-redux';
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';
import PinCodeDialogeBox from '../../../components/DialogeBox/PinCodeDialogeBox'
import { genfunction } from '../../../helpers'
import { actionAddGiftCardHold, actionResetGiftCardHoldState, actionRecalculateGiftCardHold } from 'actions';
import { actionStartAppLoader, actionEndAppLoader } from 'actions';
import { actionShopCardAddGiftCard, actionResetCouponAlreadyApplied, actionResetCouponRemoveReset } from 'actions';
import { actionResetUniqueCouponCardHoldState } from 'actions';
import { actionDeleteUniqueCoupon } from 'actions';

const { HighestCouponAlreadyApplied, HideCoupons, HideGiftCards, GiftCardEnterPinTitle, GiftCardEnterPinSubTitle1, UseGiftcardPIN, CouponNotApplicableOnOtherPaymentMsg } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {},
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    btnAlign: {
        marginTop: '17px'
    }
}));

const CouponGiftCard = props => {
    const [state, setState] = React.useState({ couponCode: '' });
    const { products } = props;
    const classes = useStyles();
    const [giftCardno, setgiftCardno] = useState("");
    const [Pin, setPin] = useState("");
    const [showPinPopUp, setShowPinPopUp] = useState("");
    const [errormsg, seterrormsg] = useState("");
    const [colorState, setColorState] = React.useState('');

    const dispatch = useDispatch();
    const { GiftCardHold, GiftCardHoldLoading, GiftCardHoldError } = useSelector(state => state.reducerGiftCardHold);
    const events = useSelector(state => state.reducerShopCart.events);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    const donation = useSelector(state => state.reducerShopCart.donation);
    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const gatickets = useSelector(state => state.reducerShopCart.GATickets);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

    useEffect(() => {
        seterrormsg(GiftCardHoldError)
    }, [GiftCardHoldError]);


    useEffect(() => {
        if (GiftCardHoldLoading)
            actionStartAppLoader(dispatch)
        else
            actionEndAppLoader(dispatch);
    }, [GiftCardHoldLoading]);

    useEffect(() => {
        if (GiftCardHold.GiftcardHoldRef)
            ValidateAndAddGiftCard(GiftCardHold)
    }, [GiftCardHold]);

    useEffect(() => {
        RecalculationGiftCard();
    }, [events, donation])

    const ValidateAndAddGiftCard = (giftcardholdresponse) => {
        if (giftcardholdresponse.HoldAmount == 0) {
            seterrormsg('Giftcard is already consumed');
        }
        else {
            actionShopCardAddGiftCard(dispatch, giftcardholdresponse);
            actionResetGiftCardHoldState(dispatch);
        }
    }

    const RecalculationGiftCard = () => {
        const totalamount = genfunction.subproducttotal(events, cashless, donation, transactionfee.transactionFee[0], membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts);
        if (totalamount != 0 && cashless.length > 0) {
            actionRecalculateGiftCardHold(dispatch);
        }
    }

    const CheckGiftCard = (giftcardNo) => {
        const totalamount = genfunction.subproducttotal(events, cashless, donation, transactionfee.transactionFee[0], membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts);
        if (totalamount <= 0) {
            seterrormsg('Please add item in cart before applying Giftcard.')
        }
        else if (giftCardno == '') {
            seterrormsg('Please enter Giftcard number.')
        }
        else {

            if (UseGiftcardPIN == "false") {
                actionAddGiftCardHold(dispatch, giftcardNo);
                setgiftCardno('');
            }
            else {
                setPin("");
                setShowPinPopUp(true);
            }
        }
    }

    const hasamount = () => {
        const totalamount = genfunction.subproducttotal(events, cashless, donation, transactionfee.transactionFee[0], membershipPackages, gatickets, giftcards.giftcards, orderProducts, donationProducts);
        return totalamount > 0;
    }

    const openerrorpopup = () => {
        return (errormsg != "")
    }

    const errorcancelhandle = () => {
        actionResetGiftCardHoldState(dispatch);
        actionResetUniqueCouponCardHoldState(dispatch);
        actionResetCouponAlreadyApplied(dispatch);
        actionResetCoupon(dispatch);
        setgiftCardno('');
        seterrormsg('');
    }

    const reducerCoupon = useSelector(state => state.reducerCoupon);
    const shopcartreducer = useSelector(state => state.reducerShopCart);
    const uniqueCouponHolds = useSelector(state => state.reducerUniqueCouponHolds);

    const handleChange = (e) => {

        setState({ ...state, couponCode: e.target.value });
    }

    useEffect(() => {
        if (reducerCoupon.couponError !== undefined && reducerCoupon.couponError.length > 0) {
            seterrormsg(reducerCoupon.couponError);
        }
    }, [reducerCoupon.couponError]);

    useEffect(() => {
        if (shopcartreducer !== undefined && shopcartreducer.couponAlreadyApplied) {
            seterrormsg(HighestCouponAlreadyApplied);
        }
    }, [shopcartreducer.couponAlreadyApplied]);

    useEffect(() => {
        if (uniqueCouponHolds !== undefined && uniqueCouponHolds.UniqueCouponError.length > 0) {
            seterrormsg(uniqueCouponHolds.UniqueCouponError);
            actionEndCouponLoading(dispatch);
        }
    }, [uniqueCouponHolds.UniqueCouponError]);

    useEffect(() => {
        if (shopcartreducer !== undefined && shopcartreducer.removeCoupon.length > 0) {
            actionDeleteUniqueCoupon(dispatch, shopcartreducer.removeCoupon);
            actionResetCouponRemoveReset(dispatch);
        }
    }, [shopcartreducer.removeCoupon]);

    useEffect(() => {
        if (reducerCoupon.loading)
            actionStartAppLoader(dispatch)
        else
            actionEndAppLoader(dispatch);
    }, [reducerCoupon.loading]);

    const redirectCall = (couponCode) => {

        if (couponCode.length > 0) {

            if (!CheckUniqueCouponAlreadyApplied(couponCode)) {
                actionGetCoupon(dispatch, couponCode);
                setState({ ...state, couponCode: '' });

                if (shopcartreducer.events.filter(x => x.PaymentOption === "OtherPay").length > 0) {
                    setColorState('info');
                    seterrormsg(CouponNotApplicableOnOtherPaymentMsg)
                }
            }
            else {
                seterrormsg("Unique Coupon already applied, please remove existing coupon and try again.");
            }
        }
    }

    const CheckUniqueCouponAlreadyApplied = (couponCode) => {

        let exist = false;
        if (events && events.length > 0) {

            events.map(e => {

                if (e.CouponItems.filter(x => x.UniqueCouponCode == couponCode && x.isUniqueCoupon).length > 0) {
                    exist = true;
                }
            });
        }

        return exist;
    }

    const GetPinPopupButtonText = () => {
        if (UseGiftcardPIN == "optional")
            return "Skip, I don???t have one";
        else if (UseGiftcardPIN == "required")
            return "Cancel";
    }

    const PinConfirmHandler = () => {
        if (Pin == undefined || Pin == "") {
            seterrormsg("Please Enter valid Pin")
        }
        else {
            setShowPinPopUp(false);
            actionAddGiftCardHold(dispatch, giftCardno + "--" + Pin);
            setgiftCardno('');
        }
    }

    const PinCancelHandler = () => {
        setShowPinPopUp(false);
        if (UseGiftcardPIN == "optional") {
            actionAddGiftCardHold(dispatch, giftCardno);
        }
    }

    const onChangePinHandler = (pin) => {
        setPin(pin);
    }

    const GiftCardsOnly = () => {
        let res = false;

        if (giftcards.giftcards && giftcards.giftcards.length > 0 && giftcards.giftcards.filter(x => x.AddedToCart === true).length > 0) {
            res = true;
        }

        if ((events && events.length > 0) || (membershipPackages && membershipPackages.length > 0) || (gatickets && gatickets.length > 0) || (orderProducts && orderProducts.length > 0) || (donationProducts && donationProducts.length > 0)) {
            res = false;
        }

        return res;
    }
    return (
        <Grid>
            <ErrorHandling color={colorState} msg={errormsg} open={openerrorpopup()} handleclose={errorcancelhandle} />
            <PinCodeDialogeBox open={showPinPopUp} button1text={GetPinPopupButtonText()} button2text="OK"
                button1clickhandler={PinCancelHandler} button2clickhandler={PinConfirmHandler} pinTextChange={onChangePinHandler}
                title={GiftCardEnterPinTitle} message={GiftCardEnterPinSubTitle1} ></PinCodeDialogeBox>
            {HideCoupons === false || HideGiftCards === false ?

                <Grid item xs={12}>
                    <Card>
                        <CardHeader className={classes.tourheaderbox}
                            title="Apply a Coupon or Gift Card"
                            titleTypographyProps={{ color: "inherit" }}
                        />
                        <CardContent>
                            <Grid container>

                                <Grid container item sm={12} >
                                    {HideCoupons === false ? <Grid item sm={6} xs={12}>
                                        <TextField id="standard-basic"
                                            onChange={e => handleChange(e)}
                                            label="Enter Coupon Code"
                                            value={state.couponCode}
                                        />
                                        <Button className={classes.btnAlign} size="small" variant="contained" color="primary"
                                            onClick={() => redirectCall(state.couponCode)}
                                            disabled={GiftCardsOnly()}
                                        >Apply</Button>
                                    </Grid> : null}

                                    {HideGiftCards === false ? <Grid item sm={6} xs={12}>
                                        <TextField id="standard-basic" label="Enter Gift Card Number"
                                            value={giftCardno}
                                            onChange={event => {
                                                setgiftCardno(event.target.value);
                                            }} />
                                        <Button className={classes.btnAlign} size="small" variant="contained"
                                            disabled={!hasamount()}
                                            color="primary"
                                            onClick={() => { CheckGiftCard(giftCardno) }}
                                        >Apply</Button>
                                    </Grid> : null}

                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                : null}

        </Grid>
    );
};

export default CouponGiftCard;
